import { render, staticRenderFns } from "./deliverItem.vue?vue&type=template&id=78fb30b4&scoped=true"
import script from "./deliverItem.vue?vue&type=script&lang=js"
export * from "./deliverItem.vue?vue&type=script&lang=js"
import style0 from "./deliverItem.vue?vue&type=style&index=0&id=78fb30b4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78fb30b4",
  null
  
)

export default component.exports